import IconDropdown from 'emerald-ui/lib/IconDropdown';
import DropdownItem from 'emerald-ui/lib/DropdownItem';
import populateDocs from './utils/populateDocs';

let zIndex = 1000;

function getZIndex() {
  zIndex -= 1;
  return zIndex;
}

export default {
  ...populateDocs([{ component: IconDropdown, componentName: 'IconDropdown' }], 'IconDropdown'),
  description: 'The IconDropdown renders an IconButton with a DropdownMenu.',
  codeSamples: [
    {
      title: 'Default',
      scope: { DropdownItem, IconDropdown },
      whiteBackground: true,
      style: { zIndex: getZIndex() },
      code: `<IconDropdown ariaLabel="See more options" icon="more_vert">
  <DropdownItem eventKey="1">Action</DropdownItem>
  <DropdownItem eventKey="2">Another action</DropdownItem>
  <DropdownItem separator />
  <DropdownItem eventKey="3">Separated link</DropdownItem>
</IconDropdown>`,
    },
  ],
};
